import type {
  AuthParamsType,
  FinalResponseType
} from 'syf-aaas-enterprise/dist/authTypes'
import TransmitWebSDKEnterpriseAuth from 'syf-aaas-enterprise/dist/TransmitWebSDKEnterpriseAuth'
import config from 'const/config'
import { FormState } from 'typings'
import useCustomTranslation from 'hooks/useCustomTranslation'
import data from '../../config/ccpa-external-app.json'
import guid from '../../utils/guid'

export interface TransmitModuleProps {
  formValues: FormState
  popupCallback: (status?: boolean, jwt?: string) => void
}

const TransmitModule = ({
  formValues,
  popupCallback
}: TransmitModuleProps): JSX.Element => {
  const t = useCustomTranslation()

  const getPolicyParams = (): AuthParamsType => {
    return {
      header: {
        trans_id: guid.generate(),
        channel_id: 'ccpa',
        client_id: ''
      },
      first_name: formValues.firstName,
      last_name: formValues.lastName,
      ssn: null,
      address: formValues.address,
      city: formValues.city,
      region: formValues.state.value,
      zip_code: formValues.zipCode,
      language_code: t('language'),
      app_env: config.TRANSMIT_ENV,
      uid: formValues.phone,
      branding: {}
    }
  }

  const sendOTPStatus = (status: boolean, jwt: string) => {
    popupCallback(status, jwt)
  }

  const handleAuthResponse = (response: FinalResponseType) => {
    const {
      status: { responseCode, responseDesc },
      token: jwt
    } = response
    const successStatus = responseCode === '0000' && responseDesc === 'Success'
    sendOTPStatus(successStatus, jwt as string)
    return response
  }

  const conf = JSON.stringify(data)
  return (
    <div>
      <TransmitWebSDKEnterpriseAuth
        data-testid="transmit-sdk"
        config={conf}
        params={getPolicyParams()}
        handleAuthResponse={handleAuthResponse}
      />
    </div>
  )
}

export default TransmitModule
